import { render, staticRenderFns } from "./AkIgnoreCheck.vue?vue&type=template&id=10f4a4a4&"
import script from "./AkIgnoreCheck.vue?vue&type=script&lang=js&"
export * from "./AkIgnoreCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/teamleader-v2-bp/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10f4a4a4')) {
      api.createRecord('10f4a4a4', component.options)
    } else {
      api.reload('10f4a4a4', component.options)
    }
    module.hot.accept("./AkIgnoreCheck.vue?vue&type=template&id=10f4a4a4&", function () {
      api.rerender('10f4a4a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/AkIgnoreCheck.vue"
export default component.exports